Determines the list of currencies to be provided.

Currently only two codes are defined:

- `All` will provide every currency that SEEK supports in a job posting flow.

- `SEEKMarket` will provide currencies associated with the markets SEEK is active in.
